import { useEffect } from 'react';
import { isProduction } from './is-production.js';

export const useProductionWarning = isProduction() ? () => {} : useEffect;
